// Same 5-tone placeholder palette as Book#cover_tone (app/models/book.rb),
// computed client-side for cart items that were never server-rendered.
const COVER_TONES = 5

export function coverToneFor(internalCode) {
  return (((internalCode ?? 0) % COVER_TONES) + COVER_TONES) % COVER_TONES
}
